import React from 'react';
import BaseComponent from './BaseComponent';
import Events from './Events';
import Entries from './Entries';
import {connect} from 'react-redux';

export class PureVenues extends BaseComponent {
    render() {
        const {venues} = this.props;

        return <div className="venues">
            <div className="venue">
                <div className="venue-info">
                    <h3>Wellington Brass</h3>
                </div>
                <Entries band="Wellington Brass" showDates={true} />
                <div className="venue-info">
                    <h3>Martyn Smith</h3>
                </div>
                <Entries accompanist="Martyn Smith" showDates={true} />
            </div>
            {venues.toList().map(venue => <div key={venue.name} className="venue">
                <div className="venue-info">
                    <h3>{venue.name}</h3>
                    <p>{venue.description}</p>
                </div>
                <Events venue={venue} />
            </div>)}
        </div>;
    }
}

function mapStateToProps({app}) {
    return {venues: app.get('venues')};
}

export default connect(mapStateToProps)(PureVenues);



/** WEBPACK FOOTER **
 ** ./src/components/Venues.jsx
 **/